import { render } from "./NewsletterView.vue?vue&type=template&id=498f49c6&scoped=true"
import script from "./NewsletterView.vue?vue&type=script&lang=js"
export * from "./NewsletterView.vue?vue&type=script&lang=js"

import "./NewsletterView.vue?vue&type=style&index=0&id=498f49c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-498f49c6"

export default script